import { CommandHandlerProvider } from '@/Application/CommandHandlerProvider'
import { FetchNewsCommandHandler } from '@/Application/News/FetchNewsCommandHandler'
import { InMemoryNewsRepository } from '../InMemoryNewsRepository'
import { NewsRepository } from '@/Domain/News'
import { AxiosNewFactory, AxiosNewRepository } from '../Persistence/Axios'
import { AxiosApiClient } from '@/Infrastructure/ApiClient'
import { SessionTokenStorage } from '@/Infrastructure/Account/SessionTokenStorage'

export class FetchNewsCommandHandlerProvider
implements CommandHandlerProvider<FetchNewsCommandHandler> {
  provide (): FetchNewsCommandHandler {
    const handler = new FetchNewsCommandHandler(
      this.get()
    )
    return handler
  }

  private get (): NewsRepository {
    if (process.env.VUE_APP_API_ENV === 'local') {
      return new InMemoryNewsRepository()
    }
    return new AxiosNewRepository(new AxiosApiClient(new SessionTokenStorage()), new AxiosNewFactory())
  }
}
